import { DeviceInfo, QAV } from 'qunar-react-native';
/**
 * 用scheme打开一个URL，不用加scheme
 * URL可以是普通的url（https/http开头的）
 */
export function openURL(url, option = {}) {
    var _a, _b;
    const { type = '', data, callback, navigation } = option;
    let _url = '';
    if (!url) {
        // eslint-disable-next-line no-console
        console.warn('url为空，不能打开');
        return;
    }
    if (url.match(/^(http|https):\/\//)) {
        _url =
            DeviceInfo.scheme +
                '://hy?' +
                (type ? 'type=' + type + '&' : '') +
                'url=' +
                encodeURIComponent(url) +
                (navigation
                    ? '&navigation=' + encodeURI(JSON.stringify(navigation))
                    : '');
    }
    else if (url.match(/^\w+:\/\//)) {
        // scheme
        _url = url;
    }
    else {
        _url = DeviceInfo.scheme + '://' + url;
    }
    if (_url) {
        QAV.log('q-design-utils', 'openURL:' + _url);
    }
    // eslint-disable-next-line no-undef
    const { sendScheme } = (_b = (_a = global.Ext) === null || _a === void 0 ? void 0 : _a.Router) === null || _b === void 0 ? void 0 : _b.Bridge;
    isFunction(sendScheme) &&
        sendScheme({
            url: _url,
            data
        }, (res) => {
            // 发送后的回调
            // eslint-disable-next-line no-console
            console.info('scheme callback', {
                // 是否成功
                ret: true,
                // 数据
                data: res
            });
            isFunction(res) && callback(res);
        });
}
/**
 * 是否是数组
 * @param arr
 */
export function isValidArray(arr) {
    if (!arr) {
        return false;
    }
    return Array.isArray(arr) && arr.length > 0;
}
/**
 * 是否是对象
 * @param o
 */
export function isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
/**
 * 是否是空对象
 * @param obj
 */
export function isValidObject(obj) {
    return !!(isObject(obj) && Object.keys(obj).length);
}
/**
 * 是否是函数
 * @param func
 */
export function isFunction(func) {
    return func && {}.toString.call(func) === '[object Function]';
}
